import {createRouter, createWebHashHistory} from "vue-router";
import home from "../views/home.vue";

const routes = [
    {
        path: "/",
        redirect: "/home"
    },
    {
        path: "/home",
        name: "home",
        component: home
    },
    {
        path: "/exhibition",
        name: "exhibition",
        component: () => import("../views/exhibition.vue")
    },
    // {
    //     path: "/product",
    //     name: "product",
    //     component: () => import("../views/product/index.vue")
    // },
    // {
    //     path: "/productDetail",
    //     name: "productDetail",
    //     component: () => import("../views/product/detail.vue")
    // },
    {
        path: "/customer",
        name: "customer",
        component: () => import("../views/customer/index.vue")
    },
    {
        path: "/order",
        name: "order",
        component: () => import("../views/order.vue")
    },
    {
        path: "/new",
        name: "new",
        component: () => import("../views/new.vue")
    },
    {
        path: "/newDetail",
        name: "newDetail",
        component: () => import("../views/newDetail.vue")
    },
    {
        path: "/position",
        name: "position",
        component: () => import("../views/position.vue")
    },
    {
        path: "/positionDetail",
        name: "positionDetail",
        component: () => import("../views/positionDetail.vue")
    },
    {
        path: "/about",
        name: "about",
        component: () => import("../views/about.vue")
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

export default router;
